<div id="int-finances-main" class="w-full h-full">
  <app-internal-toolbar [title]="'internal.invoiceForm.title' | translate">
    <reactive-button
      actions
      [label]="'general.save' | translate"
      icon="save"
      variant="outlined"
      [disabled]="invoiceForm.invalid"
      (onClick)="saveInvoice()"
    ></reactive-button>
  </app-internal-toolbar>

  <div id="invoice-content" class="flex flex-row">
    <p-fluid class="w-1/2 p-4">
      <form [formGroup]="invoiceForm" class="flex flex-col gap-2">
        <p-floatlabel variant="on">
          <input pInputText formControlName="reason" autocomplete="off" />
          <label>{{ 'internal.invoiceForm.reason' | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
          <p-datepicker
            formControlName="date"
            showIcon
            iconDisplay="input"
            [showTime]="false"
            [touchUI]="true"
            [showButtonBar]="true"
            hourFormat="24"
          />
          <label>{{ 'internal.invoiceForm.date' | translate }}</label>
        </p-floatlabel>

        @if (loadingUsers()) {
          <p-skeleton width="13rem" height="2.625rem" />
        } @else {
          <p-floatlabel variant="on">
            <p-autocomplete
              formControlName="user"
              [suggestions]="filteredUsers()"
              (completeMethod)="_searchUser($event)"
              [lazy]="true"
              [completeOnFocus]="true"
              [forceSelection]="true"
              dataKey="_id"
              optionLabel="fullname"
            />
            <label>{{ 'internal.invoiceForm.user' | translate }}</label>
          </p-floatlabel>
        }

        <p-floatlabel variant="on">
          <p-select
            [options]="addressTemplates"
            (onChange)="selectAddressTemplate($event.value)"
            optionLabel="name"
          />
          <label>{{ 'internal.invoiceForm.address' | translate }}</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
          <input
            pInputText
            formControlName="addressLine1"
            autocomplete="off"
            placeholder="Fanny-Leicht Gymnasium"
          />
          <label>{{ 'internal.invoiceForm.addressLine' | translate: { line: 1 } }}</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
          <input pInputText formControlName="addressLine2" autocomplete="off" placeholder="SAK" />
          <label>{{ 'internal.invoiceForm.addressLine' | translate: { line: 2 } }}</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
          <input
            pInputText
            formControlName="addressLine3"
            autocomplete="off"
            placeholder="Fanny-Leicht-Straße 13"
          />
          <label>{{ 'internal.invoiceForm.addressLine' | translate: { line: 3 } }}</label>
        </p-floatlabel>

        <p-floatlabel variant="on">
          <input
            pInputText
            formControlName="addressLine4"
            autocomplete="off"
            placeholder="70563 Stuttgart"
          />
          <label>{{ 'internal.invoiceForm.addressLine' | translate: { line: 4 } }}</label>
        </p-floatlabel>

        <div class="flex items-center">
          <p-toggleswitch formControlName="showQR" />
          <label class="ml-2"> {{ 'internal.invoiceForm.showQR' | translate }} </label>
        </div>

        <div class="text-xl font-bold mt-2">{{ 'internal.invoiceForm.usedItems' | translate }}</div>

        <div
          class="flex flex-col rounded-sm overflow-hidden bg-neutral-800"
          formArrayName="invoiceItems"
        >
          <div class="flex flex-row bg-neutral-700">
            <button
              pButton
              [rounded]="true"
              [text]="true"
              [fluid]="false"
              (click)="addInvoiceItem()"
              class="w-fit h-fit ml-auto"
            >
              <mat-icon>add</mat-icon>
            </button>
          </div>

          <div
            id="form-invoice-item-list-list"
            class="min-h-14 flex flex-col"
            cdkDropList
            #invoiceList="cdkDropList"
            [cdkDropListData]="invoiceItems"
            [cdkDropListConnectedTo]="[availableList]"
            (cdkDropListDropped)="useItem($event)"
          >
            @for (iItem of invoiceItems; track iItem; let i = $index) {
              <div
                cdkDrag
                [cdkDragData]="iItem.value"
                class="form-invoice-item-list-item flex flex-row gap-2 pl-2 pr-2 items-center h-14"
                [formGroupName]="i"
              >
                <mat-icon cdkDragHandle style="margin: auto; width: 40px">drag_handle</mat-icon>
                <div *cdkDragPreview>
                  {{
                    iItem.get('description')?.value +
                      ': ' +
                      iItem.get('quantity')?.value +
                      'x ' +
                      iItem.get('unitPrice')?.value +
                      ' €'
                  }}
                </div>
                <div *cdkDragPlaceholder class="drag-placeholder" style="min-height: 72px"></div>

                <p-floatlabel variant="on">
                  <input
                    pInputText
                    [fluid]="false"
                    formControlName="description"
                    autocomplete="off"
                  />
                  <label>{{ 'internal.invoiceForm.description' | translate }}</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                  <input
                    pInputText
                    [fluid]="false"
                    formControlName="additionalInfo"
                    autocomplete="off"
                  />
                  <label>{{ 'internal.invoiceForm.additionalInfo' | translate }}</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                  <p-inputnumber
                   [pt]="{pcInputText: {root: {class: 'w-20'}}}"
                    [fluid]="false"
                    formControlName="quantity"
                    autocomplete="off"
                  />
                  <label>{{ 'internal.invoiceForm.quantity' | translate }}</label>
                </p-floatlabel>

                <p-floatlabel variant="on">
                  <p-inputnumber
                   [pt]="{pcInputText: {root: {class: 'w-32'}}}"
                    [fluid]="false"
                    formControlName="unitPrice"
                    mode="currency"
                    currency="EUR"
                    locale="de-DE"
                    autocomplete="off"
                  />
                  <label>{{ 'internal.invoiceForm.unitPrice' | translate }}</label>
                </p-floatlabel>

                <!-- <button pButton [rounded]="true" [text]="true" (click)="removeInvoiceItem(i)">
                  <mat-icon>delete</mat-icon>
                </button> -->
              </div>
            }
          </div>

          <div class="flex flex-row h-14 items-center mt-auto bg-neutral-700">
            <span class="ml-auto mr-4 text-lg"
              >{{ 'internal.invoiceForm.total' | translate }}: {{ total.toFixed(2) }} €</span
            >
          </div>
        </div>

        <div class="text-xl font-bold mt-2">
          {{ 'internal.invoiceForm.availableItems' | translate }}
        </div>
        <div
          id="form-invoice-available-list"
          class="min-h-14 flex flex-col bg-neutral-800 rounded-sm overflow-hidden"
          cdkDropList
          #availableList="cdkDropList"
          [cdkDropListData]="unusedAvailTransactions"
          [cdkDropListConnectedTo]="[invoiceList]"
          (cdkDropListDropped)="unuseItem($event)"
          [cdkDropListEnterPredicate]="unusePredicate"
        >
          @for (trans of unusedAvailTransactions; track trans; let i = $index) {
            <div
              cdkDrag
              [cdkDragData]="trans"
              class="form-invoice-available-list-item h-14 flex flex-row gap-2 pl-2 pr-2 items-center"
            >
              <div *cdkDragPreview class="h-14">{{ trans.reason + ': ' + trans.amount.toFixed(2) + ' €' }}</div>
              <div *cdkDragPlaceholder class="drag-placeholder h-14"></div>
              <mat-icon cdkDragHandle style="width: 40px">drag_handle</mat-icon>
              <div style="margin-right: auto">{{ trans.reason }}</div>
              <div>{{ trans.amount.toFixed(2) }} €</div>
            </div>
          }
        </div>
      </form>
    </p-fluid>

    <div id="invoice-preview" class="w-1/2">
      <embed
        class="w-full h-full"
        style="min-height: 1000px"
        name="plugin"
        [src]="pdfData()"
        type="application/pdf"
      />
    </div>
  </div>
  <canvas id="barcode" style="display: none"></canvas>
</div>
